import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './ProgressItem.module.css';
export default function ProgressItem({ size = 16, variant = 'default', className = '', 'data-testid': dataTestId, }) {
    const containerStyle = {
        width: `${size}px`,
        height: `${size}px`,
    };
    return (_jsxs("div", { className: `${styles.container} ${styles[variant]} ${className}`, style: containerStyle, "data-testid": dataTestId ?? 'progress-item', children: [_jsx("div", { className: styles.background, "data-testid": 'progress-background' }), _jsx("div", { className: styles.indicator, "data-testid": 'progress-indicator' })] }));
}
